import { requester } from "App"
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { useEffect, useState } from "react"


function TestDevicePage() {
    const [isMounted, setMounted] = useState(false);
    const [store, setStore] = useState([]);
    const [selectStoreCode, setSelectStoreCode] = useState([]);
    const [machine, setMachine] = useState([])

    useEffect(() => {
        setMounted(true);
    }, [])
    useEffect(() => {
        requester.findAllStores((result) => {
            setStore(result.data);
        })
    }, [isMounted])

    const testBtn = (storeCode) => {
        setSelectStoreCode(storeCode);
    };


    useEffect(() => {
        if (isMounted) {
            let data = {
                storeCode: selectStoreCode,
            };
            requester.findAllMachineByStore(data, (result) => {
                setMachine(result.data)

            });
        }
    }, [selectStoreCode]);
    const test = () => {        
        let data = {
            storeCode: selectStoreCode,
        };
        console.log(data)

        requester.findByDeviceIdAndPort(data, (result) => {
            console.log(result.data);
        });
    };

    // useEffect(() => {
    //     if (isMounted) {
    //         let data = {
    //             storeCode: selectStoreCode
    //         }            
    //         requester.findAllMachineByStore(data, (result) => {
    //             setMachine(result.data)                
    //         })
    //     }
    // }, [])




    // id 값을 받아와서, 그 id 에 해당하는 storeCode 값 받아와서 
    // 그 storeCode를 이용하여, deviceId: test007, port: ttyS3 
    // 이 결괏값을 뽑기

    return (
        <Container>
            <Container>
                <VerticalFlex>
                    <FlexChild>
                        <HorizontalFlex>
                            <FlexChild>
                                {store && store.map((data, index) => {
                                    return (
                                        <div
                                            key={index}
                                            style={{ cursor: "pointer", backgroundColor: "#f4f4f4", margin: "10px" }}
                                            onClick={() => {
                                                setSelectStoreCode(data.storeCode); 
                                                test(); 
                                            }}
                                        >
                                            <P>스토어 네임 : {data.storeName}</P>
                                            <P>스토어 코드 : {data.storeCode}</P>
                                        </div>
                                    )
                                })}
                            </FlexChild>
                            <FlexChild>
                                {machine && machine.map((item, index) => {
                                    return (
                                        <div>
                                            {item.vendingName}
                                        </div>
                                    )
                                })}
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </Container>
    )

}
export default TestDevicePage